import { Selector } from 'reselect'
import { createDeepEqualSelector } from 'Redux/selectors/index'

import { FeedCampaignsState } from 'Redux/reducers/feedReducer'

type TState = {
  feed: FeedCampaignsState
}

const getState: Selector<TState, FeedCampaignsState> = state => state.feed

export const getAwaitingTracksSelector = createDeepEqualSelector(
  getState,
  ({ tracks }) => tracks
)

export const getReviewedTracksSelector = createDeepEqualSelector(
  getState,
  ({ reviewedTracks }) => reviewedTracks
)

export const getTotalAwaitingTracksSelector = createDeepEqualSelector(
  getState,
  ({ totalFeed }) => totalFeed
)

export const getTotalReviewedTracksSelector = createDeepEqualSelector(
  getState,
  ({ totalReviewed }) => totalReviewed
)

export const getFeedDetails = createDeepEqualSelector(
  getState,
  ({ feedDetails }) => feedDetails
)

export const getIsLimitReached = createDeepEqualSelector(
  getState,
  ({ isLimitReached }) => isLimitReached
)
